import API_BASE_URL from '../Config/config';

/**
 * Updates the user's learning consistency by logging a meaningful activity.
 * 
 * @param {string} userId - The ID of the user.
 * @param {string} activityType - Type of activity (e.g., 'DOCUMENT_OPEN', 'MCQ_SUBMIT')
 * @param {string} moduleName - Name of the module (e.g., 'Elite', 'Bootcamp')
 * @param {string} referenceId - Optional reference ID (e.g., technology name, task ID)
 * @param {object} details - Optional extra details
 */
export const updateLearningConsistency = async (userId, activityType, moduleName, referenceId = null, details = null) => {
  if (!userId) return;

  try {
    const response = await fetch(`${API_BASE_URL}/user/learning-consistency`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'user-id': userId
      },
      body: JSON.stringify({
        user_id: userId,
        activity_type: activityType,
        module_name: moduleName,
        reference_id: referenceId,
        details
      })
    });

    if (!response.ok) {
      console.warn('Failed to update learning consistency');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error updating learning consistency:', error);
  }
};

export const getLearningConsistency = async (userId, period = 'monthly') => {
  if (!userId) return { success: false, consistency: [] };

  try {
    const response = await fetch(`${API_BASE_URL}/user/learning-consistency?user_id=${userId}&period=${period}`, {
      headers: {
        'user-id': userId
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch learning consistency');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching learning consistency:', error);
    return { success: false, consistency: [] };
  }
};
